<template>
  <div>
    <div class="t_header" v-if="w_width<888">
      <div class="fx_cs t_topbar">
        <img src="../assets/img/homepage/logotop.png" style="height: 28px" />
        <i class="iconfont iconzu1714" style="color: #FFFFFF" @click="change()"></i>
      </div>
      <div class="t_maindiv1" style="height: 340px">
        <img src="../assets/img/bg/1.jpg" style="height: 340px">
        <div class="t_mes">
          <img src="../assets/img/1.png" style="width: 122px">
          <div class="t_title">
            <div>TMIP产品体系</div>
            <div>MES 生产管理</div>
            <div />
          </div>
        </div>
      </div>
    </div>
    <div class="header" v-else>
      <div class="topbar">
        <img src="../assets/img/homepage/logotop.png" />
        <myheader></myheader>
      </div>
      <div class="widtol mesdiv1">
        <div class="mesdiv2">
          <span class="messp1">TMIP产品体系</span>
          <span class="messp2">MES 生产管理</span>
        </div>
        <div class="mesdiv3">
          <img src="../assets/img/1.png">
        </div>
      </div>
    </div>
    <div class="t_maindiv1" style="height: 136px" v-if="w_width<888">
      <img src="../assets/img/bg/2.jpg" style="height: 200px;">
      <div class="t_txt9">
        针对纺织印染企业的生产过程特点，以生产计划排程、工艺质量控制、品种成本核算、智慧仓储为主要核心模块，推出的生产管理平台
      </div>
    </div>
    <div class="mesdiv4" v-else>
      <div class="widtol mesdiv5">
        <span class="messp3">MES 生产管理</span>
        <span class="messp4">针对纺织印染企业的生产过程特点，以生产计划排程、工艺质量控制、品种成本核算、<br>智慧仓储为主要核心模块，推出的生产管理平台。</span>
      </div>
    </div>
    <div v-if="w_width<888">
      <div class="t_mes_info">
        <div class="t_mes_txt">核心模块</div>
        <img src="../assets/img/2.png" style="width: 100%;">
        <div class="t_mes_txt2">生产计划排程</div>
        <div class="t_mes_txt3">
          全面管理加工流程、生产工艺，辅助机台作业排程，预测加工交货期。精细化批次管理，加工流程同步数据采集，结合现场看板技术，及时准确把握生产过程每一环节的数据，进而实现厂内生产资源合理调配，提高产能
        </div>
      </div>
      <div class="t_mes_info" style="background: #FFFFFF">
        <img src="../assets/img/3.png" style="width: 100%;">
        <div class="t_mes_txt2">工艺加工质量</div>
        <div class="t_mes_txt3">
          建立标准工艺库，设定对应的工序的工艺参数，对生产过程中设备状态进行实时监控，确保加工参数与工艺条件吻合，提高生产质量。在生产工序过程中通过条码采集终端、工业平板等实施采集加工数据，通过现场终端及时上报。提高设备使用效能，也方便了之后的产品质量追溯
        </div>
      </div>
      <div class="t_mes_info">
        <img src="../assets/img/4.png" style="width: 100%;">
        <div class="t_mes_txt2">精细化成本核算</div>
        <div class="t_mes_txt3">
          精准把握加工过程中的工艺流程、设备耗费、原料价格、辅料耗材、产量构成等信息，根据实际生产状态（良品率、返修率等），归集企业各项成本费用，一键成本核算相关产品价格。核算精准可靠，及时反馈各品种成本变化曲线
        </div>
      </div>
    </div>
    <div class="mesdiv6" v-else>
      <span class="messp5">核心模块</span>
      <div class="mesdiv7 widtol">
        <div class="mesdiv8 txt-left">
          <img src="../assets/img/2.png" style="width:487px;height:280px">
        </div>
        <div class="mesdiv8">
          <div class="mesdiv9">
            <span class="messp6">生产计划排程</span>
            <span class="messp7">全面管理加工流程、生产工艺，辅助机台作业排程，预测加工交货期。精细<br>
              化批次管理，加工流程同步数据采集，结合现场看板技术，及时准确把握生<br>
              产过程每一环节的数据，进而实现厂内生产资源合理调配，提高产能</span>
          </div>
        </div>
      </div>
      <div class="mesdiv7 widtol">
        <div class="mesdiv8">
          <div class="mesdiv9" style="margin-left:60px;padding-left:0px">
            <span class="messp6">工艺加工质量</span>
            <span class="messp7">建立标准工艺库，设定对应的工序的工艺参数，对生产过程中设备状态<br>
              进行实时监控，确保加工参数与工艺条件吻合，提高生产质量。在生产<br>
              工序过程中通过条码采集终端、工业平板等实施采集加工数据，通过现<br>
              场终端及时上报。提高设备使用效能，也方便了之后的产品质量追溯</span>
          </div>
        </div>
        <div class="mesdiv8 txt-right">
          <img src="../assets/img/3.png" style="width:467px;height:288px">
        </div>
        
      </div>
      <div class="mesdiv7 widtol">
        <div class="mesdiv8 txt-left">
          <img src="../assets/img/4.png" style="width:520px;height:248px">
        </div>
        <div class="mesdiv8">
          <div class="mesdiv9">
            <span class="messp6">精细化成本核算</span>
            <span class="messp7">精准把握加工过程中的工艺流程、设备耗费、原料价格、辅料耗材、产<br>
              量构成等信息，根据实际生产状态（良品率、返修率等），归集企业各<br>
              项成本费用，一键成本核算相关产品价格。核算精准可靠，及时反馈各<br>
              品种成本变化曲线</span>
          </div>
        </div>
      </div>
    </div>
    <!---首页弹出----->
    <mt-popup
      v-model="boxShow"
      position="right">
      <div style="display: block;padding: 40px 7%;" :style="{width:w_width+'px',height:w_height+'px'}">
        <div style="text-align: right">
          <span style="font-size: 25px" @click="boxShow=false">✕</span>
        </div>
        <div class="t_list" @click="goto('/#')">首页</div>
        <div class="t_list fx_cs" @click="listShow=true">
          TMIP产品体系
          <i class="iconfont iconlujing3278 t_icon2"></i>
        </div>
        <div v-show="listShow">
          <div class="t_t_list" @click="boxShow=false">MES 生产管理</div>
          <div class="t_t_list" @click="goto('/wms')">WMS 智慧仓储</div>
          <div class="t_t_list" @click="goto('/mtr')">MTR 物料溯源</div>
          <div class="t_t_list" @click="goto('/emv')">EMV 生产可视化</div>
        </div>
        <div class="t_list" @click="goto('/service')">服务与支持</div>
        <div class="t_list" style="border: 0" @click="goto('/aboutus')">关于我们</div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import util from "../components/util";
export default util.useCommon({
  data() {
    return {
      w_width:0,
      boxShow: false,
      listShow:true,
      w_height:0
    };
  },
  watch: {
  },
  methods: {
    change(){
      this.boxShow = true;
      console.log(this.boxShow);
    },
    goto(add) {
      this.backtop();
      this.$router.push(add);
    },
    backtop() {
      this.$emit('gotoTop');
    }
  },
  mounted() {
    console.log(window.innerWidth);
    this.w_width = window.innerWidth;
    this.w_height = window.innerHeight;
  },
  activated() {
  }
});
</script>
<style lang="less" scoped>
  .header {
    background-image: url(../assets/img/bg/1.jpg);
    height: 520px;
  }
  .mesdiv1{
    padding-top: 70px;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
  }
  .mesdiv2{
    color: #ffffff;
    padding-top: 70px;
    .messp1{
      font: normal normal normal 26px/56px Microsoft YaHei;
      letter-spacing: 0px;
    }
    .messp2{
      font: normal normal normal 44px/56px Microsoft YaHei;
      letter-spacing: 0px;
      display: block;
      padding-top: 10px;
      position: relative;
    }
    .messp2::before{
      content: '';
      width: 88px;
      height: 3px;
      background-color: #536DFE;
      position: absolute;
      bottom: -20px;
      left: 0px;
    }
  }
  .mesdiv3 img{
    width: 312px;
    height: 311px;
  }
  .mesdiv4{
    background-image: url("../assets/img/bg/2.jpg");
    }
  
</style>
